import SimpleSchema from 'simpl-schema';

import store from '../../config/configureStore';
import {
  crimeAgainstPropertyCodes,
  gamblingOffense,
  kidnappingOffenses,
  drugNarcoticOffenses,
  motorVehicleTheftOffenseCode,
  motorVehicleTheftPropertyTypes,
} from 'simpl-schema-validation/helpers/Codes/UCR';

import { getCategoryOfCode, getDataOfDictionaryOptions, isEmptyValue } from 'utils/functions';
import { displayDateTime } from 'reducers/TimeReducer';
import moment from 'moment';

export const incPropertiesSchema = () => {
  SimpleSchema.setDefaultMessages({
    messages: {
      en: store?.store.getState().incident.ibrsValidationRules?.incProperty || {},
    },
  });

  return new SimpleSchema({
    allStatus: {
      type: Array,
      optional: true,
      custom() {
        // NIBRS-2019.2-74: Property segment
        let countStatus = new Map();
        this.value.forEach((status) => {
          countStatus.set(status, countStatus.has(status) ? countStatus.get(status) + 1 : 1);
        });

        let errorFlag = false;
        for (let key of countStatus.keys()) {
          if (countStatus.get(key) > 10 && key !== '0') {
            // errorFlag = true;
          }
        }

        if (errorFlag) {
          return 'NIBRS-2019.2-74';
        }
      },
    },

    'allStatus.$': {
      type: String,
      optional: true,
      blackbox: true,
      custom() {},
    },

    propertyItem: {
      type: String,
      label: 'NIBRS-2019.2-71: Property Lose Type',
      optional: true,
      custom() {
        let foundProperty = this.obj.incProperties.length > 0 ? true : false;

        if (this.obj.offense.values.statuteDetails?.FBICode === '35B') {
          if (!foundProperty) {
            return 'NIBRS-2019.2-71';
          }
        }

        //NIBRS-2019.2-57: Report Contents Validation
        if (
          kidnappingOffenses.includes(this.obj.offense?.values?.statuteDetails?.FBICode) ||
          gamblingOffense.includes(this.obj.offense?.values?.statuteDetails?.FBICode) ||
          crimeAgainstPropertyCodes.includes(this.obj.offense?.values?.statuteDetails?.FBICode) ||
          drugNarcoticOffenses.includes(this.obj.offense?.values?.statuteDetails?.FBICode)
        ) {
          if (!foundProperty) {
            return 'NIBRS-2019.2-57 A';
          }
        } else {
          if (foundProperty) {
            return 'NIBRS-2019.2-57 B';
          }
        }
      },
    },

    propertySubstance: {
      type: String,
      label: 'NIBRS-2019.2-73: Property Lose Type',
      optional: true,
      custom() {
        if (this.obj.offense.values.statuteDetails?.FBICode === '35A') {
          let foundItem = this.obj.incProperties.find(
            (ip) => ip.incPropertyDetails.values.parentType?.toLowerCase() === 'substance'
          );
          if (!foundItem) {
            return 'NIBRS-2019.2-73';
          }
        }
      },
    },

    type: {
      type: String,
      label: 'Property Type',
      optional: true,
      custom() {
        const codePropertyCategory = store.store.getState().dictionary.codePropertyCategory;
        const propertyType = this.value
          ? getCategoryOfCode(codePropertyCategory, this.value)
          : this.value;

        if (
          this.obj.offense.values.statuteDetails?.FBICode === '23A' ||
          this.obj.offense.values.statuteDetails?.FBICode === '23B'
        ) {
          if (
            [
              '1',
              '01',
              '3',
              '03',
              '4',
              '04',
              '5',
              '05',
              '12',
              '15',
              '18',
              '24',
              '28',
              '29',
              '30',
              '31',
              '32',
              '33',
              '34',
              '35',
              '37',
              '39',
              '66',
              '78',
            ].includes(propertyType)
          ) {
            return 'NIBRS-2019.2-80';
          }
        }

        if (this.obj.offense.values.statuteDetails?.FBICode === '23C') {
          if (
            [
              '1',
              '01',
              '3',
              '03',
              '5',
              '05',
              '12',
              '15',
              '18',
              '24',
              '28',
              '29',
              '30',
              '31',
              '32',
              '33',
              '34',
              '35',
              '37',
              '39',
            ].includes(propertyType)
          ) {
            return 'NIBRS-2019.2-81';
          }
        }

        if (this.obj.offense.values.statuteDetails?.FBICode === '23H') {
          if (['3', '03', '5', '05', '24', '28', '37'].includes(propertyType)) {
            return 'NIBRS-2019.2-83';
          }
        }

        // NIBRS-2019.2-79: Property Description
        if (['220', '240'].includes(this.obj.offense.values.statuteDetails?.FBICode)) {
          if (['29', '30', '31', '32', '33', '34', '35'].includes(propertyType)) {
            return 'NIBRS-2019.2-79';
          }
        }

        // NIBRS-2019.2-82: Property Description
        if (
          ['23D', '23E', '23F', '23G'].includes(this.obj.offense.values.statuteDetails?.FBICode)
        ) {
          if (
            [
              '3',
              '03',
              '5',
              '05',
              '24',
              '28',
              '29',
              '30',
              '31',
              '32',
              '33',
              '34',
              '35',
              '37',
            ].includes(propertyType)
          ) {
            return 'NIBRS-2019.2-82';
          }
        }

        // NIBRS-2019.2-77: Property Description
        if (
          this.obj.offense.values.statuteDetails?.FBICode === '35A' &&
          this.obj.offense.values.offenseAttempted === false
        ) {
          if (propertyType !== '10') {
            return 'NIBRS-2019.2-77 Property Description';
          }
        }

        //NIBRS-2019.2-76: Property Description
        if (
          this.obj.offense?.values?.statuteDetails?.FBICode === '240' &&
          this.obj?.originProperty?.values?.quantity > 0
        ) {
          if (!['3', '03', '5', '05', '24', '28', '37'].includes(propertyType)) {
            return 'NIBRS-2019.2-76';
          }
        }

        if (this.obj.property.values.recoveredDate) {
          if (!this.value || this.value?.length === 0) return 'NIBRS-2019.2-90';
        }

        // NIBRS-2019.2-206: Property Description
        if (
          this.obj.offense?.values?.statuteDetails?.FBICode !== '35A' &&
          this.obj.offense?.values?.statuteDetails?.FBICode !== '23H' &&
          ['10'].includes(propertyType)
        ) {
          return 'NIBRS-2019.2-206';
        }

        //NIBRS-2019.2-205: Property Description
        if (
          ['item', 'firearm', 'jewelry', 'structure', 'vehicle'].includes(
            this.obj.parentType.toLowerCase()
          ) &&
          ['10'].includes(propertyType)
        ) {
          return 'NIBRS-2019.2-205';
        }
      },
    },

    value: {
      type: SimpleSchema.Integer,
      label: 'NIBRS-2019.2-90: Property Date Recovered',
      optional: true,
      custom() {
        const codePropertyCategory = store.store.getState().dictionary.codePropertyCategory;
        const propertyType = getCategoryOfCode(codePropertyCategory, this.obj.property.values.type);

        if (this.obj.property.values.recoveredDate) {
          if (this.value === null || this.value === undefined) return 'NIBRS-2019.2-90';
        }

        if (['9', '09', '22', '48', '65', '66', '99'].includes(propertyType) && this.value !== 0) {
          return 'NIBRS-2019.2-86';
        }

        if (propertyType === '88' && this.value !== 1) {
          return 'NIBRS-2019.2-87';
        }
      },
    },

    status: {
      type: String,
      label: 'Property Lose Type',
      optional: true,
      custom() {
        const codePropertyLossType = store.store.getState().dictionary.codePropertyLossType;
        const propertyStatusCategory = getCategoryOfCode(codePropertyLossType, this.value);
        // NIBRS-2019.2-69: Property Lose Type
        if (propertyStatusCategory === 'unknown') {
          if (this.obj.parentType === 'substance') {
            if (
              this.obj?.originProperty?.values?.quantity ||
              this.obj?.originProperty?.values?.quantityMeasure ||
              this.obj?.originProperty?.values?.substanceType
            ) {
              return 'NIBRS-2019.2-69';
            }
          }
        }

        // NIBRS-2019.2-195: Property Lose Type
        if (propertyStatusCategory === 'seized') {
          if (this.obj.parentType === 'substance') {
            const codeSubstanceCategory = store.store.getState().dictionary.codeSubstanceCategory;

            if (
              getCategoryOfCode(
                codeSubstanceCategory,
                this.obj?.originProperty?.values?.substanceType
              ) === 'x'
            ) {
              if (
                this.obj?.originProperty?.values?.quantity ||
                this.obj?.originProperty?.values?.quantityMeasure
              ) {
                return 'NIBRS-2019.2-195';
              }
            } else if (
              !this.obj?.originProperty?.values?.quantity ||
              !this.obj?.originProperty?.values?.quantityMeasure
            ) {
              return 'NIBRS-2019.2-195';
            }
          }
        }

        if (propertyStatusCategory === 'unknown') {
          if (
            this.obj.property.values.value ||
            this.obj.property.values.stolenVehicles ||
            this.obj.property.values.recoveredVehicles ||
            this.obj.property.values.type ||
            this.obj.property.values.recoveredDate
          )
            return 'NIBRS-2019.2-68';
        }

        if (
          (kidnappingOffenses.includes(this.obj.offense.values.statuteDetails?.FBICode) ||
            gamblingOffense.includes(this.obj.offense.values.statuteDetails?.FBICode) ||
            crimeAgainstPropertyCodes.includes(this.obj.offense.values.statuteDetails?.FBICode)) &&
          this.obj.offense.values.offenseAttempted === true
        ) {
          if (propertyStatusCategory !== 'none' && propertyStatusCategory !== 'unknown') {
            return 'NIBRS-2019.2-59';
          }
        }

        if (
          kidnappingOffenses.includes(this.obj.offense.values.statuteDetails?.FBICode) ||
          gamblingOffense.includes(this.obj.offense.values.statuteDetails?.FBICode) ||
          crimeAgainstPropertyCodes.includes(this.obj.offense.values.statuteDetails?.FBICode) ||
          drugNarcoticOffenses.includes(this.obj.offense.values.statuteDetails?.FBICode)
        ) {
          if (!this.value) {
            return 'NIBRS-2019.2-58';
          }
        }

        if (
          this.obj.offense.values.statuteDetails?.FBICode === '200' &&
          this.obj.offense.values.offenseAttempted === false
        ) {
          if (propertyStatusCategory !== 'burned') {
            return 'NIBRS-2019.2-63';
          }
        }

        if (
          this.obj.offense.values.statuteDetails?.FBICode === '250' &&
          this.obj.offense.values.offenseAttempted === false
        ) {
          if (
            propertyStatusCategory !== 'countrfeit' &&
            propertyStatusCategory !== 'recovered' &&
            propertyStatusCategory !== 'seized'
          ) {
            return 'NIBRS-2019.2-64';
          }
        }

        if (
          this.obj.offense.values.statuteDetails?.FBICode === '290' &&
          this.obj.offense.values.offenseAttempted === false
        ) {
          if (propertyStatusCategory !== 'destroyed') {
            return 'NIBRS-2019.2-65';
          }
        }

        if (
          (this.obj.offense.values.statuteDetails?.FBICode === '35A' ||
            this.obj.offense.values.statuteDetails?.FBICode === '35B') &&
          this.obj.offense.values.offenseAttempted === false
        ) {
          if (propertyStatusCategory !== 'seized' && propertyStatusCategory !== 'none') {
            return 'NIBRS-2019.2-62';
          }
        }

        if (
          (this.obj.offense.values.statuteDetails?.FBICode === '39A' ||
            this.obj.offense.values.statuteDetails?.FBICode === '39B' ||
            this.obj.offense.values.statuteDetails?.FBICode === '39C' ||
            this.obj.offense.values.statuteDetails?.FBICode === '39D') &&
          this.obj.offense.values.offenseAttempted === false
        ) {
          if (propertyStatusCategory !== 'seized') {
            return 'NIBRS-2019.2-67';
          }
        }

        if (
          (this.obj.offense.values.statuteDetails?.FBICode === '100' ||
            this.obj.offense.values.statuteDetails?.FBICode === '220' ||
            this.obj.offense.values.statuteDetails?.FBICode === '510') &&
          this.obj.offense.values.offenseAttempted === false
        ) {
          if (
            propertyStatusCategory !== 'none' &&
            propertyStatusCategory !== 'recovered' &&
            propertyStatusCategory !== 'stolen' &&
            propertyStatusCategory !== 'unknown'
          ) {
            return 'NIBRS-2019.2-61';
          }
        }

        if (
          this.obj.offense.values.statuteDetails?.FBICode === '280' &&
          this.obj.offense.values.offenseAttempted === false
        ) {
          if (propertyStatusCategory !== 'none' && propertyStatusCategory !== 'recovered') {
            return 'NIBRS-2019.2-60';
          }
        }

        //TODO: Improve the logic
        if (
          (this.obj.offense.values.statuteDetails?.FBICode === '120' ||
            this.obj.offense.values.statuteDetails?.FBICode === '210' ||
            this.obj.offense.values.statuteDetails?.FBICode === '240' ||
            this.obj.offense.values.statuteDetails?.FBICode === '23A' ||
            this.obj.offense.values.statuteDetails?.FBICode === '23B' ||
            this.obj.offense.values.statuteDetails?.FBICode === '23C' ||
            this.obj.offense.values.statuteDetails?.FBICode === '23D' ||
            this.obj.offense.values.statuteDetails?.FBICode === '23E' ||
            this.obj.offense.values.statuteDetails?.FBICode === '23F' ||
            this.obj.offense.values.statuteDetails?.FBICode === '23G' ||
            this.obj.offense.values.statuteDetails?.FBICode === '23H' ||
            this.obj.offense.values.statuteDetails?.FBICode === '26A' ||
            this.obj.offense.values.statuteDetails?.FBICode === '26B' ||
            this.obj.offense.values.statuteDetails?.FBICode === '26C' ||
            this.obj.offense.values.statuteDetails?.FBICode === '26D' ||
            this.obj.offense.values.statuteDetails?.FBICode === '26E' ||
            this.obj.offense.values.statuteDetails?.FBICode === '26F' ||
            this.obj.offense.values.statuteDetails?.FBICode === '26G' ||
            this.obj.offense.values.statuteDetails?.FBICode === '270') &&
          this.obj.offense.values.offenseAttempted === false
        ) {
          if (propertyStatusCategory !== 'stolen' && propertyStatusCategory !== 'recovered') {
            return 'NIBRS-2019.2-66';
          }
        }

        //NIBRS-2019.2-182: Property Recovered/Stolen Check.
        if (
          propertyStatusCategory === 'recovered' &&
          this.obj.incProperty?.incPropertyDetails.values.status !== 'STOLEN'
        ) {
          if (
            this.obj.offense.values.statuteDetails?.FBICode !== '250' &&
            this.obj.offense.values.statuteDetails?.FBICode !== '280'
          ) {
            return 'NIBRS-2019.2-182';
          }
        }

        //Make the logic more organized
        if (
          propertyStatusCategory === 'burned' ||
          propertyStatusCategory === 'countrfeit' ||
          propertyStatusCategory === 'recovered' ||
          propertyStatusCategory === 'seized' ||
          propertyStatusCategory === 'destroyed'
        ) {
          if (this.obj.parentType === 'vehicle') {
            if (
              !this.obj.property.values.value ||
              !this.obj.property.values.type
              //  ||
              // !this.obj.property.values.stolenVehicles ||
              // !this.obj.property.values.recoveredVehicles
            ) {
              return 'NIBRS-2019.2-187';
            }
          } else if (this.obj.parentType !== 'vehicle') {
            if (!this.obj.property.values.value || !this.obj.property.values.type) {
              return 'NIBRS-2019.2-187';
            }
          }

          if (propertyStatusCategory === 'recovered') {
            if (!this.obj.property.values.recoveredDate) {
              return 'NIBRS-2019.2-187';
            }
          }
        } else if (propertyStatusCategory === 'stolen') {
          if (this.obj.parentType === 'vehicle') {
            const isMVTOffense =
              this.obj.offense?.values?.statuteDetails?.FBICode === motorVehicleTheftOffenseCode;
            const currentPropertyType = getDataOfDictionaryOptions(
              'codePropertyCategory',
              'Code',
              'Category',
              this.obj.property.values.type
            );
            const isMVTPropertyType = motorVehicleTheftPropertyTypes.includes(currentPropertyType);

            if (
              (!this.obj.property.values.value && this.obj.property.values.value !== 0) ||
              !this.obj.property.values.type ||
              (isMVTOffense &&
                isMVTPropertyType &&
                isEmptyValue(this.obj.property.values?.stolenVehicles)) ||
              (!this.obj.property.values.recoveredDate &&
                this.obj.property.values.recoveredFromOtherJurisdiction === true) ||
              (!isEmptyValue(this.obj.property.values.recoveredVehicles) &&
                !this.obj.property.values.recoveredVehicles &&
                (this.obj.property.values.recoveredDate || this.obj.property.values.recoveredValue))
            ) {
              return 'NIBRS-2019.2-188';
            }
          } else if (this.obj.parentType !== 'vehicle') {
            if (
              (!this.obj.property.values.value && this.obj.property.values.value !== 0) ||
              !this.obj.property.values.type
            ) {
              return 'NIBRS-2019.2-188';
            }
          }
        }

        // NIBRS-2019.2-77: Property Description
        if (
          this.obj.offense.values.statuteDetails?.FBICode === '35A' &&
          this.obj.offense.values.offenseAttempted === true
        ) {
          if (propertyStatusCategory !== 'seized') {
            return 'NIBRS-2019.2-77 Property Loss';
          }
        }
      },
    },

    propertyDrugType: {
      type: String,
      optional: true,
      custom() {
        //NIBRS-2019.2-98: Property Drug Type

        let statusWithType = new Set();
        for (let incProperty of this.obj.incProperties) {
          const property = this.obj.properties?.find(
            (p) =>
              p.propertyDetails.incIncidentPropertyId ===
              incProperty.incPropertyDetails.incIncidentPropertyId
          );

          const lossType = incProperty.incPropertyDetails?.values?.status;
          const substanceType = property?.propertyDetails?.values?.substanceType;
          if (!substanceType || !lossType) continue;

          const key = `${substanceType} - ${lossType}`;
          if (statusWithType.has(key)) return 'NIBRS-2019.2-98';
          statusWithType.add(key);
        }
      },
    },

    stolenVehicles: {
      type: SimpleSchema.Any,
      optional: true,
      custom() {
        //NIBRS-2019.2-94: Property Stolen Motor Vehicles
        if (isEmptyValue(this.value)) {
          return;
        }
        const stolenVehicles = parseInt(this.value);
        const isMVTOffense =
          this.obj.offense?.values?.statuteDetails?.FBICode === motorVehicleTheftOffenseCode;
        const isVehicleType = this.obj.parentType === 'vehicle';

        if (
          isMVTOffense &&
          isVehicleType &&
          (isNaN(stolenVehicles) || stolenVehicles < 0 || stolenVehicles > 99)
        ) {
          return 'NIBRS-2019.2-94';
        }
      },
    },
    recoveredVehicles: {
      type: SimpleSchema.Any,
      optional: true,
      custom() {
        const stolenQuantity = parseInt(this.obj.property?.values?.stolenVehicles);
        const recoveredQuantity = parseInt(this.obj.recoveredVehicles);

        if (recoveredQuantity && stolenQuantity && recoveredQuantity > stolenQuantity) {
          return 'NIBRS-2019.2-200';
        }
      },
    },
    recoveredDate: {
      type: SimpleSchema.Any,
      optional: true,
      custom() {
        // need to validate that recoveredDate is not before the incident date
        if (this.obj.recoveredDate && this.obj.incidentDate) {
          const incidentDate = displayDateTime(this.obj.incidentDate);

          const recoveredDate = this.obj.recoveredDate;

          if (
            moment(recoveredDate).format('YYYY-MM-DD') < moment(incidentDate).format('YYYY-MM-DD')
          ) {
            return 'NIBRS-2019.2-202';
          }
        }
      },
    },
  });
};
